import React, { useState } from 'react';
import LineSelectionLookup from './LineSelectionLookup'
import { Button, Space, Modal, Tabs, Empty, Switch, Row, Col, message, notification, Popconfirm } from 'antd';
import AddLine from './AddLine';
import { createLineSelection } from '../util/APIUtils';
import shortid from 'shortid';


function LineSelectionLookupWithAdd(props) {
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [key, setKey] = useState("key")

    const showModal = () => {
        setOpen(true);
    };

    const handleOk = (vals) => {
        console.log(vals)
        setLoading(true);
        let name;
        if(vals.selection == 1) {
            name = vals.name_1 + "-" + vals.name_2 + "-" + vals.name_3 + "-" + vals.name_4 + "G"
        } else {
            name = vals.name_5
        }

        let lineSelection = {
            cropId: props.projectInfo.cropId,
            name: name
        }
        
        let promise;
        promise = createLineSelection(lineSelection)
        if (!promise) {
            return;
        }
        promise.then(response => {
            setLoading(false)
            setOpen(false);
            // props.setExistingItems(props.existingItems.push(response))
        }).catch(error => {
            console.log(error)
            setOpen(false);
            setLoading(false);
        });
    };

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };
    return (
        <div>
            <Modal
                title="Eingabe Linien/Sortenbezeichnung"
                width={800}
                visible={open}
                confirmLoading={loading}
                footer={''}
            >
                <AddLine projectInfo={props.projectInfo} onClose={handleCancel} loading={loading} handleOk={handleOk}/>
            </Modal>

            <Space>
                <LineSelectionLookup {...props} key={shortid.generate()} />
                <Button type='primary' onClick={showModal}> + Linie</Button>
            </Space>
        </div>
    )
}

export default LineSelectionLookupWithAdd